import styled from "styled-components";
import ProjectCard from "../components/ProjectCard";
import sudokuBackground from "../assets/sudokuBackground.jpg"
import aeroLabsBackground from "../assets/mazda.png"

const CardsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 40px;
    width: 90%;
    height: 90%;
    margin: auto;
    position: absolute;
    top: 10%;
    left: 3%;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        left: 50%;
        transform: translateX(-50%);
    }
`

function Projects(){
    return(
        <CardsContainer>
            <ProjectCard
                title="Sudoku"
                titleSize="3.4"
                shortDescription="Simple Sudoku game, written in Blazor and compiled to WebAssembly. First ever project. Best experienced on desktop."
                longDescription="This was initially written in Windows Forms as a
                                    university project, but I decided to rewrite it as
                                    an excuse to try out Blazor and WebAssembly. Thankfully,
                                    having good experience in C# meant that rewriting everything
                                    in Blazor was decently approachable. I did try to
                                    embed the app directly within this page, but because .NET
                                    hates me, the custom HTML element functionality within Blazor
                                    just straight up broke a few months before I made it. Oh well.
                                    You live you learn."
                image={sudokuBackground}
                appName="sudoku"
            />
            <ProjectCard
                title="AeroLabs"
                titleSize="2.6"
                shortDescription="Coming soon..."
                longDescription="This is a 3D visualizer created in Unity, where users are able to
                                    visually customize a car to their liking. It will also use
                                    actually real parts, and provide links to buy all of those parts,
                                    to help users find the right setup for their car. Might also try
                                    out some wheel alignment and fitment stuff."
                image={aeroLabsBackground}
                appName="carRenderer"
            />
        </CardsContainer>
    )
}

export default Projects;